import React from 'react';
import { useSelector } from 'react-redux';

export default function useUserSelector() {
  const UserListData = useSelector((state) => state?.user?.list_data) || [];
  const UserViewListData = useSelector((state) => state?.user?.View_data) || [];
  const IncentiveListData = useSelector((state) => state?.user?.incentive_list) || [];
  // console.log('IncentiveListData', IncentiveListData);
  // console.log('UserViewListData in selector', UserViewListData);
  return { UserListData, UserViewListData, IncentiveListData };
}
